import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LocationState {
  coords: { lat: number; lng: number } | null;
  label: string;
  communityId: string | null;
  communityName: string | null;
  isCommunity: boolean;
  isPromptOpen: boolean;

  setLocation: (
    coords: { lat: number; lng: number },
    label: string,
    community?: { id?: string; name?: string; isCommunity?: boolean } | null
  ) => void;
  setPromptOpen: (isOpen: boolean) => void;
  clearLocation: () => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      coords: null,
      label: "",
      communityId: null,
      communityName: null,
      isCommunity: false,
      isPromptOpen: false,

      setLocation: (coords, label, community) =>
        set({
          coords,
          label,
          isPromptOpen: false,
          communityId: community?.id || null,
          communityName: community?.name || null,
          isCommunity: !!community?.isCommunity,
        }),
      setPromptOpen: (isOpen) => set({ isPromptOpen: isOpen }),
      clearLocation: () =>
        set({
          coords: null,
          label: "",
          communityId: null,
          communityName: null,
          isCommunity: false,
          isPromptOpen: true,
        }),
    }),
    {
      name: "ruchira-location",
      partialize: (state) => ({
        coords: state.coords,
        label: state.label,
        communityId: state.communityId,
        communityName: state.communityName,
        isCommunity: state.isCommunity,
      }),
    }
  )
);
